module.exports = __webpack_public_path__ + "static/media/closeIcon.11e01811.svg";